<template>
  <div class="people-info">
    <div class="photo">
      <img v-if="imgSrc"
           v-img-loader
           :data-src="imgSrc"
           :data-default-src="'/img/img-default/img-composer-default.png'"
      >
      <img v-else :src="require('@/assets/images/img-composer/img-composer-default.png')">
    </div>
    <div class="name">
      <RouterLink v-if="labelId" :to="{ name: 'composerById', params: { locale: $i18n.localePath(), id: labelId }}"
                  class="label" tag="p"
      >
        {{ label }}
      </RouterLink>
      <p v-else-if="label" class="label">
        {{ label }}
      </p>
      <h1 v-if="title" class="title">
        {{ title }}
      </h1>
      <p v-if="subTitle" class="sub-title">
        {{ subTitle }}
      </p>
    </div>
    <p v-if="alias !== ''" class="alias">
      {{ aliasTitle }} : {{ alias }}
    </p>
    <p v-if="desp" class="desp">
      {{ desp }}
    </p>
  </div>
</template>
<script>
import ImgLoader from '@/directives/ImgLoader'

export default {
  directives: {
    ImgLoader
  },
  props: {
    'type': {
      type: String,
      default: ''
    },
    'imgSrc': {
      type: String,
      default: null
    },
    'title': {
      type: String,
      default: ''
    },
    'subTitle': {
      type: String,
      default: ''
    },
    'aliasTitle': {
      type: String,
      default: ''
    },
    'alias': {
      type: String,
      default: ''
    },
    'desp': {
      type: String,
      default: ''
    },
    'label': {
      type: String,
      default: ''
    },
    'labelId': {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.people-info{
  .photo{
    width: 122px;
    height: 122px;
    border-radius: 12px;
    overflow: hidden;
    float: left;
    margin-bottom: 16px;
    img{
      width: 100%;
      height: auto;
    }
  }
  .name{
    overflow: hidden;
    padding-left: 24px;
    .title{
      font-size: 24px;
      font-weight: 500;
      line-height: 1.6;
      color: $grey-50;
      margin: 0;
      padding: 0;
    }
    .sub-title{
      font-size: 16px;
      font-weight: bold;
      line-height: 1.6;
      color: $grey-9b;
      margin: 4px 0;
    }
    .label{
      display: inline;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.6;
      color: $grey-9b;
      margin: 0 0 4px;
      cursor: pointer;
    }
    &:after{
      content: "";
      display: block;
      clear: both;
    }
  }
  .alias{
    display: block;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.6;
    color: $grey-7d;
    margin: 16px 0;
    &:before{
      content: "";
      display: block;
      clear: both;
    }
  }
  .desp{
    font-size: 16px;
    font-weight: bold;
    line-height: 1.6;
    color: $grey-7d;
    margin: 0;
    padding-bottom: 20px;
    &:before{
      content: "";
      display: block;
      clear: both;
    }
  }
  &:after{
    content: "";
    display: block;
    clear: both;
  }
}

@media only screen and (max-width: 1023.98px) {
  .people-info{
    .photo{
      width: 71px;
      height: 71px;
    }
    .name{
      padding-left: 8px;
      .title{
        font-size: 16px;
      }
      .sub-title,
      .label{
        font-size: 14px;
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .people-info{
    margin-bottom: 16px;
    .alias{
      color: $grey-9b;
      margin-bottom: 16px;
    }
  }
}
</style>
